export default __webpack_public_path__ + "static/media/person4.d3f992ae.svg";